module.exports = __webpack_public_path__ + "img/bg.e14426a0.jpg";